import { axiosInstance } from 'apis/config/axios';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { isLoginAtom } from 'store/auth';

const useAuth = () => {
  const [isLogin, setIsLogin] = useAtom(isLoginAtom);

  const accessToken = sessionStorage.getItem('accessToken');

  useEffect(() => {
    if (accessToken) {
      axiosInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
      setIsLogin({ isLogin: true });
    }
  }, [accessToken]);

  return {
    isLogin,
    setIsLogin,
  };
};
export default useAuth;
